export default `
	guestList {
		... on GuestListGuest {
			guestName
			subline
			image {
				id
				width
				height
				url
			}
			instagram
		}
	}
`;
